<template >
  <div id="record-index">
    <div class="container">
      <div class="wrapper">
        <!-- <header><img class="back" src="@/assets/img/icon_back.png" @click="toUrl('home')"></header> -->
        <!-- <header><img src="/assets/img/logo.png" alt=""></header> -->
        <ul class="tag-area">
          <li class="record" @click="tab = 0">
            <span>交易紀錄</span><div :class="{'line': true, 'active': tab == 0}"></div>
          </li>
          <li class="record" @click="tab = 1">
            <span>點數紀錄</span><div :class="{'line': true, 'active': tab == 1}"></div>
          </li>
      </ul>
        <div class="content-area">
          <!-- 交易紀錄 -->
          <div class="record-area" v-show="tab == 0">
            <div class="select-area">             
              <Myselects
              @va="childValue"
                :num="count"
                :sel="sel"
                ></Myselects>
            </div>
            <div class="record-box">
              <div class="record-title">查詢區間發票金額累計</div>
              <h4 class="record-price font-r"><span>{{ formatPrice(amountOfConsume) }}</span>元/{{ timesOfConsume }}次</h4>
              <p class="record-date font-r">消費區間：{{ user.startDate }} - {{ user.endDate }}</p>
            </div>
            <div class="no-list" v-show="filterList == 0">
              <img src="@/assets/img/no-record.png" alt="">
            </div>
            <div class="record-list" v-show="filterList !== 0">
              <!-- <div class="">{{filterList}}</div> -->
              <div class="list" v-for="(item, index) in filterList" :key="index" @click="openDetail(item)">
                <ul class="list-box">
                  <li class="list-content"><p class="record-location">{{ item.location }}</p><p class="record-date">{{ item.date }}</p></li>
                  <li class="list-content"><p>發票金額</p><p class="font-r">NT${{ formatPrice(item.price) }}</p></li>
                  <!-- <li class="list-content"><p>點數折抵</p><p class="font-r">{{ formatPrice(item.discount) }}</p></li>
                  <li class="list-content"><p>累積點數</p><p class="get-points font-r"><span class="icon"></span>{{ formatPrice(item.getPoints) }}點</p></li> -->
                </ul>
                <div class="next"><img src="@/assets/img/icon_next.png" alt=""></div>
              </div>
            </div>
            <p class="info">交易紀錄將於24小時後更新，實際資料以本公司系統紀錄為主，交易紀錄僅呈現近一年內資訊</p>
          </div>
          <!-- 詳細 -->
          <div class="detail-area" v-show="isDetail">
            <div class="detail-wrapper" :item="item">
              <header><img class="back" src="@/assets/img/icon_back.png" @click="isDetail = false">
              <p>交易明細</p><img class="back">
              </header>
                <div class="detail-title">
                  <p class="do-location"><span class="location"></span>{{ item.location }}</p>
                  <div class="documents">
                    <div class="do-content">
                      <div class="bar-box">
                        <div class="bar"></div>
                      </div>
                      <div class="do-list">
                        <div><p v-if="item.invoice">發票號碼</p><p>交易單號</p></div>
                        <div><p v-if="item.invoice">{{ item.invoice }}</p><p>{{ item.bill }}</p></div>
                      </div>
                    </div>
                    <p class="detail-time">{{ item.date }}</p>
                  </div>
                </div>
                <div class="detail-content">
                  <div class="product">
                    <h2>消費商品</h2>
                    <div class="product-title">
                      <div class="product-name text-start">商品名稱</div>
                      <div class="product-amount text-center">數量</div>
                      <div class="product-amount text-end">金額</div>
                    </div>
                    <div class="product-list" v-for="list in item.detail" :key="list.id">
                      <div class="product-name text-start">{{ list.productName }}</div>
                      <div class="product-amount text-center font-r">{{ list.productCount }}</div>
                      <div class="product-amount text-end font-r">${{ formatPrice(list.productAmount) }}</div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="detail-bg"></div>
          </div>
          <!-- 點數紀錄 -->
          <div class="points-history-area" v-show="tab == 1">
            <div class="text-area">
              <div class="point-card">
                <div class="point-box">
                  <div class="point-title">
                    <div>
                      累積
                    </div>
                    <div>
                      總點數
                    </div>
                  </div>
                  <h2 class="font-r">{{ formatPrice(user.memberPoints) }}</h2>
                </div>
                <div class="point-box">
                  <div class="point-title">
                    <div>
                      90天內
                    </div>
                    <div>
                      到期點數
                    </div>
                  </div>
                  <h2 class="font-r">{{ formatPrice(user.memberPointsExpiringWithin90Days) }}</h2>
                </div>
              </div>
              <ul class="points-info">
                <li class="points-content">消費點數於發票開立後2個工作日內歸戶，活動贈點依活動說明為準。</li>
                <li class="points-content">點數區間：{{ getStartDate }}~{{ getEndDate }}</li>
              </ul>
            </div>
            <div class="points-area">
              <div class="no-list" v-show="user.pointsHistory.length == 0">
                <img src="@/assets/img/no-record.png" alt="">
              </div>
              <div class="points-list" v-show="user.pointsHistory.length !== 0">
                <div class="history-box" v-for="list in user.pointsHistory" :key="list.id">
                  <div class="history-title">
                    <div class="text-start">交易日期 :</div>
                    <div class="text-start">類別 :</div>
                    <div class="text-start">效期 :</div>
                  </div>
                  <div class="history-content">
                    <div class="text-start">{{ list.date }}</div>
                    <div class="text-start">{{ list.type }}</div>
                    <div class="text-start">{{ list.expire_date }}</div>
                  </div>
                  <div class="history-point">
                    {{ list.getPoints > 0 ? '+' : '' }}{{ list.getPoints }}
                  </div>
                </div>
              </div>
              <p class="info">點數紀錄將於24小時後更新，實際資料以本公司系統紀錄為主，點數紀錄僅呈現近一年內資訊</p>
            </div>
            
          </div>
        </div>
 
      </div>
    </div>
  </div>
</template>

<script>
import Selects from "@/components/select";
import Api from '@/utils/Api';

export default {
  name: 'record',
  components: {
     Myselects: Selects  //注册组件
  },
  data() {
    return {
      select:"",
      tab:0,
      item:{},
      isDetail:false,
      sel:["全集團","Under Amour", "ISPO", "Helly Hansen"],  //下拉框的内容 （Array类型） 必传
      count: 4,  //下拉框条数  （Number类型） 必传
      user:{
          memberPoints: null,
          memberPointsExpiringWithin90Days: null,
          history:[],
          pointsHistory:[]
        }
    }
  },
  mounted() {
    document.body.style.background = '#ffffff'
    this.initial();
    // 如果缺少 mana 資料
    if (Object.keys(this.$route.params).length == 0) {
      this.$router.push({ name: 'Home' });
    }
  },
  computed: {
    getStartDate: function () {
      let day = new Date();
      day.setFullYear(day.getFullYear() - 1);
      return day.toLocaleDateString();
    },
    getEndDate: function () {
      let day = new Date();
      day.setDate(day.getDate());
      return day.toLocaleDateString();
    },
    getYear: function() {
      let Today = new Date();
      return Today.getFullYear()
    },
    filterList() {
      var _this = this;
      if(_this.select == "全集團"){
        return this.user.history;
      }
      return this.user.history.filter(function (v) {return v.brand.indexOf(_this.select) !== -1} );
    },
    timesOfConsume() {
      return this.filterList.length;
    },
    amountOfConsume() {
      return this.filterList.reduce((accumulator, currentValue) => accumulator+currentValue.price, 0);
    }
  },
  methods: {
    formatPrice: function (val) {
      if(val === '-'){
        return '-';
      }
      let formatNUmber = new Intl.NumberFormat('en-US')
      return formatNUmber.format(val)
    },
    openDetail: function (item) {
      this.isDetail = true;
      this.item = item;
      window.scrollTo(0, 0);
    },
    toUrl(val) {
      this.$router.push(`/${ val }`);
    },
    childValue(index, val) {
      this.select = val;
    },
    async initial() {
      let uid = this.$root.$data.uid;
      let accessToken = this.$root.$data.accessToken;

      let api = new Api(uid, accessToken);
      let { data: { data } } = await api.getShoppingRecord();

      this.user.memberPoints = parseInt(this.$route.params.memberPoints);
      this.user.memberPointsExpiringWithin90Days = parseInt(this.$route.params.memberPointsExpiringWithin90Days);
      this.user.history = data.history;
      this.user.startDate = data.startDate;
      this.user.endDate = data.endDate;

      let { data: { pointHistory } } = await api.getPointHistory();
      this.user.pointsHistory = pointHistory;
    }
  },
};
</script>

<style scoped>

.container {
  padding: 0;
}
header {
  justify-content: space-between;
  padding: 0 6%;
}
header .back {
  height: 45%;
}
header p {
  color: #ffffff;
  margin-right: 6%;
}
/***** 交易紀錄頁 *****/
/* tag-area */
.tag-area {
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    padding: 0;
    margin: 0; 
}
.tag-area .record {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    cursor: pointer;
    background-color: #100316;
    padding: 7px 0 9px 0;
    list-style: none;
    color: #FFFFFF;
}
.tag-area .record .line.active {
    border: 2px solid #ffffff;
    width: 50%;
    border-radius: 50px;
    margin: 5px auto 0 auto;
    background: #fff;
}
.tag-area .record .line {
    border: 2px solid #100316;
    width: 50%;
    border-radius: 50px;
    margin: 5px auto 0 auto;
}
/* record-area */
.select-area {
  padding: 0 6%;
  margin-top: 15px;
}
.selects {
  z-index: 5;
  position: relative;
}
.record-box {
    background:url(../assets/img/record-box.png) no-repeat left;
    background-size: 100%;
    margin: 15px auto;
    width: 85%;
    padding: 1.5% 0;
}
.record-box .record-title {
    font-size: 14px;
    margin: 0;
    padding: 8px 0 9px 0;
    color: #4C4C4D;
}
.record-box .record-price {
    font-size: 14px;
    margin: 10px 0 10px 0;
    font-weight: 600;
    color: #4C4C4D;
    letter-spacing: 3px;
}
.record-box .record-price span{
    font-size: 24px;
    margin: 10px 0;
    font-weight: 600;
}
.record-box .record-date {
    margin: 0;
    color: #7F7F80;
    font-size: 12px;
    padding: 0 0 12px 0;
}
@media screen and (max-width: 320px) {
    .record-box {
        padding: 1% 0;}
    .record-box .record-title{
        font-size: 14px;
        padding: 13px 0 7px 0;}
    .record-box .record-price span {
        font-size: 22px;}
    .record-box .record-price {
        margin: 7px 0 10px 0;}
    .record-box .record-date {
        padding: 0 0 12px 0;}}
@media screen and (max-width: 280px){
    .record-box {
        padding: 1% 0;}
    .record-box .record-title{
        font-size: 14px;
        padding: 4px 0 4px 0;}
    .record-box .record-price span {
        font-size: 22px;}
    .record-box .record-price {
        margin: 6px 0 5px 0;
        font-size: 12px;}
    .record-box .record-date {
        font-size: 12px;
        padding: 0 0 5px 0;}}
@media screen and (min-width: 400px) {
    .record-box .record-title{
        font-size: 16px;
        padding: 9px 0 10px 0;}
    .record-box .record-price {
        margin: 20px 0 0 0;
        font-size: 16px;}
    .record-box .record-date {
        padding: 10px 0;}}
@media screen and (min-width: 540px) {
    .record-box .record-title{
        font-size: 22px;
        padding: 12px 0 10px 0;}
    .record-box .record-price {
        margin: 31px 0 12px 0;
        font-size: 20px;}
    .record-box .record-price span {
        font-size: 28px;}
    .record-box .record-date {
        padding: 5px 0 10px 0;
        font-size: 16px;}}
/* record-list */
.list {
    text-align: end;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 10px 8%;
    border-bottom: 1px solid #DADADB;
}
.list-box {
    margin: 0;
    padding: 0;
    flex: 0 0 90%;
}
.list-box p{
    text-align: end;
    color: #B3B3B3;
    margin: 0 0 5px 0;
    font-size: 15px;
}
.list-box .list-content {
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 5px;
}
.list-box .list-content .record-location {
  color: #000;
  font-weight: 600;
  font-size: 15px;
}
.list-box .list-content .record-date {
  color: #B3B3B3;
  font-size: 15px;
}
.list-box .list-content p{
    margin: 0;
    padding: 0;
    color: #7F7F80;
    font-size: 14px;
}
.list-box .list-content .get-points {
    color: #E6A82E;
    display: inline-block;
    align-items: center;
}
.list-box .list-content .get-points .icon { 
    display: inline-block; 
    width:25px; 
    height:25px; 
    background: url(../assets/img/icon_getPoints.png) no-repeat center;
    background-size: 80%;
    white-space:nowrap; 
    letter-spacing: -1em; 
    text-indent: -99em; 
    color: transparent;
    /* *text-indent: 0;
    *zoom: expression( this.runtimeStyle['zoom'] = '1', this.innerHTML = '\3000'); */
}
.list-box .list-content .get-points .icon:before { 
    content: '\3000'; 
}
/* .list-box .list-content .get-points img {
    width: 20px;
} */
.next {
    flex: 0 0 10%;
}
.next img {
    width: 68%;
}
.no-list {
    display: flex;
    justify-content: center;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 8%;
    min-height: 40vh;
}
.no-list img {
    width: 40%;
}
.record-area .info{
    color: #9E9E9F;
    font-size: 14px;
    padding: 40px 8%;
}
/***** 詳細頁 *****/
/* .detail-area {
  height: 100vh;
} */
.detail-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 10;
    top: 0;
}
.detail-wrapper{
    height: 100vh;
    max-width: 540px;
    overflow-y: scroll;
    width: 100%;
    z-index: 20;
    position: fixed;
    left: 50%;
    top: 0;
    -webkit-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    z-index: 11;
}
.detail-title {
  background: #100316;
  text-align: start;
  padding: 10px 0 15px 0;
  box-shadow: 0px 10px 20px -2px rgba(0, 0, 0, 0.31);
  -webkit-box-shadow: 0px 10px 20px -2px rgba(0, 0, 0, 0.31);
}
.detail-title .do-location{
  margin: 0;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  padding: 0 6%;
  margin-bottom: 10px;
}
.detail-title .do-location .location {
    display: inline-block; 
    width:25px; 
    height:20px; 
    background: url(../assets/img/icon_location.png) no-repeat center;
    background-size: 80%;
    white-space:nowrap; 
    letter-spacing: -1em; 
    text-indent: -99em; 
    color: transparent;
    margin-right: 3px;
}
.detail-title .do-location .location:before { 
    content: '\3000'; 
} 
.detail-title .do-content {
  display: flex;
  padding: 0 8%;
}
.detail-title .do-content .bar-box{
  flex: 0 0 6%;
}
.detail-title .do-content .bar{
  width: 5px;
  background: #7F7F80;
  height: 100%;
  border-radius: 50px;
}
.detail-title .do-content .do-list{
  flex: 0 0 94%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.detail-title .do-content .do-list p{
  margin: 10px 0;
  color: #ffffff;
}
.detail-title .detail-time {
  color: #7F7F80;
  padding: 0 8%;
  margin: 10px 0 0 0;
}
.detail-content .product {
  padding: 0 8%;
}
.detail-content .product h2{
  text-align: start;
  font-size: 26px;
}
.detail-content .product .product-title{
  display: flex;
  margin-bottom: 20px;
}
.product-name{
  flex: 0 0 60%;
}
.product-amount{
  flex: 0 0 20%;
}
.detail-content .product .product-list {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
/***** 點數紀錄頁 *****/
.text-area {
  margin-bottom: 30px;
  padding: 0 4%;
}
.text-area h1 {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}
.text-area h2 {
  font-size: 40px;
  font-weight: bold;
  margin: 3% 0;
  }
.text-area p {
  font-size: 13px;
  color: #7F7F80;
}
.text-area .point-card {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex; 
}
.text-area .point-card .point-box{
  width: 50%;
  border: 1px solid #8B8B8B;
  border-radius: 15px;
  margin: 0 2%;
  font-weight: 500;
  padding: 15px 8%;
}
.text-area .point-card .point-box .point-title{
  font-size: 18px;
  color: #100316; 
  border-bottom: 1px solid #DADADB;
  padding-bottom: 8px;
}
.text-area .point-card .point-box h2{
  font-size: 36px;
  font-weight: bold;
  color: #E6A82E;
  margin: 0;
  padding-top: 4px;
}
@media screen and (max-width: 293px) {
  .text-area .point-card .point-box .point-title {
    font-size: 16px;
    padding-bottom: 5px;}
  .text-area .point-card .point-box h2 {
    font-size: 25px;}
}
@media screen and (min-width: 400px) {
    .text-area .point-card .point-box .point-title {
        font-size: 20px;}
    .text-area .point-card .point-box h2 {
        font-size: 40px;}}
@media screen and (min-width: 540px) {
    .text-area .point-card .point-box .point-title {
        font-size: 20px;}
    .text-area .point-card .point-box h2 {
        font-size: 40px;}}
.points-info {
  text-align: start;
  color: #7F7F80;
  padding: 0 0 0 10px;
}
.points-info .points-content {
  font-size: 14px;
  margin: 0 5px 0 25px;
}
/* points-list */
.history-box {
  margin: 0 6%;
  border-bottom:1px solid #DADADB;
  display: flex;;
  padding: 20px 0;
}
.history-box .history-title{
  font-weight: 800;
}
.flex-3 {
  flex: 0 0 33.3%;
}
.history-box .history-content {
  font-size: 18px;
  padding: 0 30px;
}
.history-box .history-point {
  flex: 1;
  color: #E6A82E;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: end;
}
.text-start {
  text-align: start;
  text-align: justify;
}
.text-center {
  text-align: center;
}
.text-end {
  text-align: end;
}
.color {
  color: #E6A82E;
}
.points-area .info {
  color: #9E9E9F;
  font-size: 14px;
  padding: 20px 8% 30px 8%;
}
</style>